import type {
  ErpMeResponse,
  UpdateErpPersonalProfileRequest
} from "@/contracts";
import { erpRequest } from "@/core/api/erp-client";

function getUserFromMe(payload: ErpMeResponse) {
  return payload.data || payload.user || payload.employee || payload.account;
}

export async function getAuthenticatedCurrentErpUser() {
  const response = await erpRequest<ErpMeResponse>("/erp/auth/me");
  return getUserFromMe(response);
}

export async function updateCurrentErpPersonalProfile(
  payload: UpdateErpPersonalProfileRequest
) {
  const response = await erpRequest<ErpMeResponse>(
    "/erp/auth/me/personal-profile",
    {
      method: "PUT",
      body: JSON.stringify(payload)
    }
  );

  return getUserFromMe(response);
}
